var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37013_928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 14.7751C0 11.7133 0 8.65161 0 5.58989C0.0167047 5.53568 0.0337502 5.48182 0.0497731 5.42761C0.238638 4.7884 0.795687 4.35715 1.46353 4.35647C4.36571 4.35306 7.26789 4.35204 10.1701 4.35647C10.992 4.35783 11.6411 5.00659 11.6425 5.82887C11.6472 8.73104 11.6466 11.6332 11.6421 14.5354C11.6414 15.0307 11.4274 15.431 11.0292 15.73C10.8437 15.8694 10.6269 15.9345 10.4097 15.9993H1.22455C1.10762 15.9604 0.986598 15.9308 0.874438 15.881C0.390003 15.6665 0.120342 15.2786 0 14.7747L0 14.7751Z",
    fill: "black",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1702 0.000589812C11.587 0.000589812 13.0038 -9.20107e-05 14.421 0.000589812C15.3752 0.00127164 15.9994 0.622753 15.9994 1.57458C16.0001 4.40824 16.0001 7.24223 15.9994 10.0759C15.9994 11.0304 15.3772 11.6536 14.4261 11.6557C14.256 11.656 14.0862 11.656 13.9161 11.6557C13.3495 11.6543 13.0536 11.3615 13.0533 10.7986C13.0526 9.04736 13.0536 7.2961 13.0526 5.54483C13.0519 4.1696 12.1624 3.14857 10.7988 2.95868C10.6873 2.943 10.5728 2.94777 10.4593 2.94777C8.71379 2.94709 6.96798 2.94777 5.22251 2.94709C4.6341 2.94709 4.34398 2.65799 4.34467 2.07095C4.34501 1.81049 4.32558 1.54594 4.36239 1.29026C4.47489 0.508889 5.07558 0.00229437 5.86854 0.00127164C7.30242 -0.00111475 8.73629 0.000589812 10.1702 0.000589812Z",
    fill: "black",
    fillOpacity: 0.05
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37013_928"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9997,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.15b0f6d14ea487eb69a65330c4e24e2d.svg";
export { ForwardRef as ReactComponent };